import React from "react";
import {
  FaUniversity,
  FaLaptopCode,
  FaUserGraduate,
  FaBuilding,
} from "react-icons/fa";
import { motion } from "framer-motion";
import "../css/Solutions.css";

export default function Solutions() {
  const solutions = [
    {
      icon: <FaUniversity />,
      title: "Schools",
      desc:
        "An integrated academic and administrative solution that helps schools operate efficiently while improving engagement across students, teachers, and parents.",
      points: [
        "Attendance, timetable, and exam management",
        "Teacher, student, and parent collaboration",
        "Academic performance monitoring",
        "Secure communication and notifications",
      ],
    },
    {
      icon: <FaUserGraduate />,
      title: "Colleges & Universities",
      desc:
        "A scalable platform designed to manage complex academic structures, departments, and performance data with precision.",
      points: [
        "Course, faculty, and department management",
        "Attendance, grading, and assessments",
        "Institution-wide academic analytics",
        "Learning platform integrations",
      ],
    },
    {
      icon: <FaLaptopCode />,
      title: "Training & Skill Centers",
      desc:
        "Purpose-built tools for managing professional training programs, certifications, and learner outcomes.",
      points: [
        "Batch scheduling and trainer allocation",
        "Trainee attendance and progress tracking",
        "Certification and assessment workflows",
        "Operational and performance reports",
      ],
    },
    {
      icon: <FaBuilding />,
      title: "Corporate Learning",
      desc:
        "Enterprise-grade learning solutions that support employee onboarding, training, and continuous skill development.",
      points: [
        "Employee onboarding and upskilling",
        "Certification and compliance tracking",
        "Engagement and performance insights",
        "Seamless HR and system integrations",
      ],
    },
  ];

  return (
    <section className="solutions">
      <div className="solutions-bg" />

      <div className="solutions-wrapper">
        {/* Header */}
        <div className="solutions-header">
          <span className="solutions-label">Solutions</span>

          <h2 className="solutions-title">
            Built for <span>Every Learning Environment</span>
          </h2>

          <p className="solutions-lead">
            Our solutions are designed to adapt to different institutional needs
            while maintaining consistency, security, and performance at scale.
          </p>
        </div>

        {/* Grid */}
        <div className="solutions-grid">
          {solutions.map((item, index) => (
            <motion.div
              key={index}
              className="solution-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.12 }}
              viewport={{ once: true }}
            >
              <div className="solution-icon">{item.icon}</div>

              <h3 className="solution-title">{item.title}</h3>

              <p className="solution-desc">{item.desc}</p>

              <ul className="solution-points">
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
